import React from 'react';
import {isNumeric, formatMoney, formatNumber, formatPercent} from '../humanize';

// Chip de variación: flecha ↑↓ + magnitud (+ % cuando se puede calcular). SIEMPRE gris
// neutro: la dirección de un cambio de configuración/presupuesto no es buena ni mala por
// sí sola. El color semántico lo decide cada renderer por `level`, nunca por el signo.
// Devuelve null si ambos lados no son numéricos o no hay cambio.
export function DeltaChip({before, after, money, currency}) {
    if (!isNumeric(before) || !isNumeric(after)) return null;
    const prev = Number(before);
    const next = Number(after);
    if (prev === next) return null;
    const delta = next - prev;
    const arrow = delta > 0 ? '↑' : '↓';
    const magnitude = money ? formatMoney(Math.abs(delta), currency) : formatNumber(Math.abs(delta));
    const pct = prev !== 0 ? formatPercent((delta / Math.abs(prev)) * 100, {signed: true}) : null;
    return (
        <span className="ald-delta">
            {arrow} {magnitude}{pct ? ` (${pct})` : ''}
        </span>
    );
}
